<template>
  <div class="viptype-container">
    <!-- Toolbar -->
    <div class="search-section">
      <div class="toolbar">
        <div class="toolbar-left">
          <span class="toolbar-tip">Manage Membership types</span>
        </div>
        <div class="toolbar-right">
          <el-button type="primary" @click="openAdd" icon="el-icon-plus">新增</el-button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <el-table
        :data="list"
        border
        stripe
        :header-cell-class-name="'headerBg'"
        class="custom-table"
        style="width: 100%"
      >
        <el-table-column type="index" label="#" width="40" align="center" />
        <el-table-column prop="name_zh" label="中文名称" min-width="180" align="center"/>
        <el-table-column prop="name_ug" label="维文名称" min-width="200" align="center">
          <template slot-scope="scope">
            <div class="ugText">{{ scope.row.name_ug }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.amount !== null && scope.row.amount !== undefined">
              ¥ {{ Number(scope.row.amount).toFixed(2) }}
            </span>
            <span v-else class="muted">无</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="170" align="center" />
        <el-table-column prop="updated_at" label="更新时间" min-width="170" align="center" />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button type="success" size="small" @click="openEdit(scope.row)">
                <i class="el-icon-edit" /> 编辑
              </el-button>
              <el-popconfirm
                class="ml-5"
                confirm-button-text="确定"
                cancel-button-text="我再想想"
                icon="el-icon-info"
                icon-color="red"
                title="确定删除该类型？"
                @confirm="handleDelete(scope.row)"
              >
                <el-button type="danger" size="small" slot="reference">
                  <i class="el-icon-remove-outline" /> 删除
                </el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Add / Edit Dialog -->
    <el-dialog
      :title="current.id ? '编辑会员类型' : '新增会员类型'"
      :visible.sync="dialogVisible"
      :width="'30%'"
      class="custom-dialog"
      :close-on-click-modal="false"
    >
      <el-form label-width="110px" size="small" class="edit-form">
        <el-form-item label="中文名称">
          <el-input v-model="current.name_zh" placeholder="e.g. 月会员" autocomplete="off" />
        </el-form-item>
        <el-form-item label="维文名称">
          <el-input
            v-model="current.name_ug"
            placeholder="e.g. ئايلىق ئەزا"
            autocomplete="off"
            class="ugText"
          />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number
            v-model="current.amount"
            :min="0"
            :step="0.1"
            :precision="2"
            :controls="false"
            placeholder="请输入价格（可为空）"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil'

export default {
  name: 'VipType',
  data() {
    return {
      list: [],
      dialogVisible: false,
      current: {
        id: null,
        name_zh: '',
        name_ug: '',
        amount: null
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.request
        .get('/namzar/admin/vipType')
        .then(res => {
          const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []
          this.list = data.map(item => ({
            id: item.id,
            name_zh: item.name_zh,
            name_ug: item.name_ug,
            amount: item.amount,
            created_at: item.created_at ? formatDateTime(item.created_at) : '',
            updated_at: item.updated_at ? formatDateTime(item.updated_at) : ''
          }))
        })
        .catch(res => {
          this.$message.error(res?.message || '获取会员类型失败')
        })
    },
    openAdd() {
      this.current = {
        id: null,
        name_zh: '',
        name_ug: '',
        amount: null
      }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.current = { ...row }
      this.dialogVisible = true
    },
    submit() {
      if (!this.current.name_zh || !this.current.name_ug) {
        this.$message.warning('请填写中/维文名称')
        return
      }
      const payload = {
        name_zh: this.current.name_zh,
        name_ug: this.current.name_ug,
        amount: this.current.amount
      }
      let api = '/namzar/admin/vipType/add'
      if (this.current.id) {
        api = '/namzar/admin/vipType/edit'
        payload.id = this.current.id
      }
      this.request
        .post(api, payload)
        .then(res => {
          if (res && (res.code === 200 || res.message)) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch(res => {
          this.$message.error(res?.message || '保存失败')
        })
    },
    handleDelete(row) {
      if (!row.id) {
        this.$message.error('缺少ID，无法删除')
        return
      }
      this.request
        .post('/namzar/admin/vipType/delete', { id: row.id })
        .then(res => {
          if (res && (res.code === 200 || res.message === '删除成功')) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        })
        .catch(res => {
          this.$message.error(res?.message || '删除失败')
        })
    }
  }
}
</script>

<style scoped>
.viptype-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

.search-section {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.toolbar-left {
  color: #909399;
  font-size: 14px;
}

.toolbar-right {
  text-align: left;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
}

.custom-table {
  border-radius: 8px;
  overflow: hidden;
  min-width: 800px;
}

.custom-table ::v-deep .el-table__header-wrapper {
  background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.custom-table ::v-deep .el-table__row:hover {
  background-color: #f5f7fa;
}

.headerBg {
  background: #eee !important;
}

.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.muted {
  color: #c0c4cc;
}

.ugText {
  direction: rtl;
}

.edit-form ::v-deep .el-form-item {
  margin-bottom: 14px;
}
</style>


